import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Title from '../Title'
import Button from '../Button';
import ButtonOption from '../ButtonOption';
import ErrorMessage from '../ErrorMessage';

const ContainerOut = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    text-align: center;
    width: 380px;
    padding: 35px 50px;

    border-radius: 10px;  
    opacity: 1;
    background: #FFFFFF80 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);

    @media only screen and (min-width: 768px) {
        padding: 50px 135px;
    }
`;

const ChildrenNumber = ({ state, setState }) => {
    const [showError, setShowError] = useState(false)
    const [view, setView] = useState("")
    useEffect(() => {
        if (view == ""){
            if (state == "None"){
                setView("8.5")
            }else if (state == "One child"){
                setView("8")
            }else if (state == "Two children"){
                setView("9")
            }else if (state == "Three or children"){
                setView("10")
            }
        }
    })
    return (
        <ContainerOut>
            <Container>
                <img src="/imagesss/All SVG/Child.svg" alt="Children" width={190}/>
                <Title title="How many children do you have?" />
                <div onClick={() => setView("8.5")}>
                    <ButtonOption
                        text="None"
                        setBtState={setState}
                        btState="None"
                        active={state === "None"}
                    />
                </div>

                <div onClick={() => setView("8")}>
                    <ButtonOption
                        text="One child"
                        setBtState={setState}
                        btState="One child"
                        active={state === "One child"}
                    />
                </div>

                <div onClick={() => setView("9")}>
                    <ButtonOption
                        text="Two children"
                        setBtState={setState}
                        btState="Two children"
                        active={state === "Two children"}
                    />
                </div>

                <div onClick={() => setView("10")}>
                    <ButtonOption
                        text="Three or more children"
                        setBtState={setState}
                        btState="Three or more children"
                        active={state === "Three or more children"}
                    />
                </div>

                {showError && <ErrorMessage text="Please select an option above" />}

                {
                    view === "" ?
                        <div onClick={() => setShowError(true)}>
                            <Button text="Next" />
                        </div>
                        :
                        <Link to={`/whakapapa/1/${view}`}>
                            <Button text="Next" />
                        </Link>
                }
            </Container>
        </ContainerOut>
    )
}

export default ChildrenNumber;